// Required to prevent 404 page to be displayed before
// the redirect is done in the handleSignoutCallback function.
export function SignoutCallback() {
  return <></>;
}
